(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["categories-slider"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const swiper = new Swiper('.category-slider', {
      loop: true,
      slidesPerView: 1,
      spaceBetween: 16,
      centeredSlides: false,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        320: {
          slidesPerView: 1,
          spaceBetween: 20,
        },
        480: {
          slidesPerView: 2,
          spaceBetween: 30,
        },
        769: {
          slidesPerView: 3,
          spaceBetween: 40,
        },
      },
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["merrell-45-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Nota: este bloque no evalua Liquid, por eso el selector es generico.
    document.querySelectorAll('[data-m45-card] .m45-cell__link, [data-m45-card] a.m45-cell__btn').forEach(function (link) {
      if (link.dataset.m45Bound) { return; }
      link.dataset.m45Bound = '1';
      link.addEventListener('click', function () {
        try {
          var card = link.closest('[data-m45-card]');
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: 'select_promotion',
            ecommerce: {
              creative_name: 'merrell-45',
              items: [{
                item_name: (card && card.getAttribute('data-name')) || '',
                item_category: (card && card.getAttribute('data-category')) || ''
              }]
            }
          });
        } catch (e) {}
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["merrell-45-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Accesibilidad: si el visitante prefiere reducir el movimiento, no autoreproducir.
    // Nota: este bloque no evalua Liquid, por eso el selector es generico.
    try {
      if (!window.matchMedia || !window.matchMedia('(prefers-reduced-motion: reduce)').matches) { return; }
      document.querySelectorAll('video[data-m45-video]').forEach(function (v) {
        v.removeAttribute('autoplay');
        if (!v.paused) { v.pause(); }
        v.setAttribute('controls', 'controls');
      });
    } catch (e) {}
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["merrell-45-tech"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Nota: este bloque no evalua Liquid; la configuracion viaja en data-attributes.
    function initTech(scope) {
      var root = scope && scope.querySelectorAll ? scope : document;
      var nodes = root.querySelectorAll('[data-m45-tech]');
      if (!nodes.length) return;
      if (typeof Swiper === 'undefined') {
        window.setTimeout(function () { initTech(document); }, 60);
        return;
      }

      nodes.forEach(function (el) {
        if (el.dataset.m45TechBound) return;
        el.dataset.m45TechBound = '1';

        var mq = window.matchMedia('(max-width: 749px)');
        var instance = null;

        function build() {
          var opts = {
            slidesPerView: parseFloat(el.getAttribute('data-per-view')) || 1.3,
            spaceBetween: parseInt(el.getAttribute('data-space'), 10) || 16,
            loop: el.getAttribute('data-loop') === 'true',
            watchOverflow: true
          };
          if (el.getAttribute('data-autoplay') === 'true' && opts.loop) {
            opts.autoplay = {
              delay: parseInt(el.getAttribute('data-autoplay-delay'), 10) || 3000,
              disableOnInteraction: false,
              pauseOnMouseEnter: true
            };
          }
          if (el.getAttribute('data-dots') === 'true') {
            opts.pagination = { el: el.querySelector('.swiper-pagination'), clickable: true };
          }
          return new Swiper(el, opts);
        }

        function apply() {
          if (mq.matches && !instance) {
            instance = build();
          } else if (!mq.matches && instance) {
            instance.destroy(true, true);
            instance = null;
          }
        }

        apply();
        if (mq.addEventListener) { mq.addEventListener('change', apply); }
        else if (mq.addListener) { mq.addListener(apply); }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initTech(document); });
    } else {
      initTech(document);
    }
    document.addEventListener('shopify:section:load', function (e) { initTech(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow2"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initSlideshow2(scope) {
      var root = scope && scope.querySelectorAll ? scope : document;
      var nodes = root.querySelectorAll('.slideshow2__swiper');
      if (!nodes.length) return;

      if (typeof Swiper === 'undefined') {
        window.setTimeout(function () { initSlideshow2(document); }, 60);
        return;
      }

      nodes.forEach(function (el) {
        if (el.classList.contains('is-initialized')) return;

        var nav = el.getAttribute('data-navigation');
        var transition = el.getAttribute('data-transition');
        var autoplay = el.getAttribute('data-autoplay') === 'true';
        var speed = parseInt(el.getAttribute('data-autoplay-speed'), 10) || 7;
        var loop = el.getAttribute('data-loop') === 'true';
        var isAdapt = el.getAttribute('data-height') === 'adapt';

        var opts = {
          slidesPerView: 1,
          loop: loop,
          speed: transition === 'instant' ? 0 : 600,
          effect: transition === 'fade' ? 'fade' : 'slide',
          fadeEffect: { crossFade: true },
          autoHeight: isAdapt
        };

        if (autoplay && loop) {
          opts.autoplay = { delay: speed * 1000, disableOnInteraction: false, pauseOnMouseEnter: true };
        }
        if (nav === 'dots') {
          opts.pagination = { el: el.querySelector('.swiper-pagination'), clickable: true };
        }
        if (nav === 'arrows') {
          opts.navigation = {
            nextEl: el.querySelector('.swiper-button-next'),
            prevEl: el.querySelector('.swiper-button-prev')
          };
        }

        el.classList.add('is-initialized');
        new Swiper(el, opts);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initSlideshow2(document); });
    } else {
      initSlideshow2(document);
    }

    // Theme Editor: reinicializar al añadir/editar la sección.
    document.addEventListener('shopify:section:load', function (e) { initSlideshow2(e.target); });
    document.addEventListener('shopify:section:select', function (e) { initSlideshow2(e.target); });
  })();

  } catch(e) { console.error(e); }
})();
})();
